import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TRANSLATIONS } from '../../../../translations';

import Typography, {
  TypographyStates,
  TypographyVariants,
  TypographyWeights,
} from '../../../ui-components/Typography/Typography';
import Button, { ButtonWidths } from '../../Button/Button';
import Image from '../../../ui-components/Image/Image';
import SmartSearchCategoryCard from './SmartSearchCategoryCard';
import Carousel from '../../../ui-components/Carousel/Carousel';

function SmartSearchNoResults({
  searchValue,
  handleNewSearch,
  popularCategories,
}) {
  const renderCategoryCards = () => {
    return popularCategories?.categories?.map((item, index) => (
      <SmartSearchCategoryCard
        key={index}
        classNames="smart-search__container--body--scrollbox__no-results--section--popular__categories--item items-center"
        item={item}
      />
    ));
  };

  return (
    <section className="smart-search__container--body--scrollbox__no-results--section">
      <div className="smart-search__container--body--scrollbox__no-results--section--message">
        <Typography
          classNames="smart-search__container--body--scrollbox__no-results--section--message__text"
          variant="p3"
        >
          <b>{TRANSLATIONS.NO_RESULT}</b> <br />
          <span>
            {TRANSLATIONS.NO_RESULTS_FOUND_FOR} “{searchValue}”
          </span>
        </Typography>
      </div>
      <div className="smart-search__container--body--scrollbox__no-results--section--cta">
        <Button
          onClick={handleNewSearch}
          width={ButtonWidths.auto}
          label={
            <Typography variant={'p3'} state={TypographyStates.white}>
              {TRANSLATIONS.MAKE_A_NEW_SEARCH}
            </Typography>
          }
        />
      </div>
      <div className="smart-search__container--body--scrollbox__no-results--section--divider" />
      <section className="smart-search__container--body--scrollbox__no-results--section--popular">
        <div className="smart-search__container--body--scrollbox__no-results--section--popular--title">
          <Image
            source={
              'https://freedome.s3.eu-central-1.amazonaws.com/icons/compass-icon.svg'
            }
            alt={'Bussola'}
            size={'x-small'}
            shape={'rounded'}
          />
          <Typography
            variant={TypographyVariants.p2}
            weight={TypographyWeights['semi-bold']}
          >
            {TRANSLATIONS.YOU_MIGHT_BE_INTERESTED}
          </Typography>
        </div>
        <Carousel classNames="gap-base">{renderCategoryCards()}</Carousel>
      </section>
    </section>
  );
}

SmartSearchNoResults.propTypes = {
  searchValue: PropTypes.string,
  handleNewSearch: PropTypes.func,
  popularCategories: PropTypes.object,
};

export default memo(SmartSearchNoResults);
